<template>
  <label class="w-full py-[11px] rounded-lg text-[14px] font-[500] px-2 text-center flex bg-[#F8F8F8] justify-center items-center text-sm tracking-tighter">
    <input
        class="ml-2 hidden w-full h-full"
        type="checkbox"
        v-bind="$attrs"
        :value="value"
        v-on="{ ...$listeners, input: onChange }"
    />
    {{ title }}
  </label>
</template>

<script>
export default {
  name:'checkBox',
  props: {
    title: {
      type: String,
      default: null,
    },
    value: {
      type: [Boolean, Number],
      default: true,
    },
  },
  methods: {
    onChange(e) {
      this.$emit('input', e.target.checked)
    },
  },
}
</script>